import React from 'react';

import { LanguageSwitcher as RDCLanguageSwitcher } from '@uncinc/react-drupal-core';

import { DEFAULT_LANGUAGE, MULTILINGUAL } from '../../config/constants';

import './style.scss';

const LanguageSwitcher: React.FC = () => {
  if (!MULTILINGUAL) {
    return null;
  }

  return (
    <RDCLanguageSwitcher
      languages={{ en: 'EN', nl: 'NL' }}
      defaultLanguage={DEFAULT_LANGUAGE}
      hideActive={false}
    />
  );
};

export default LanguageSwitcher;
